/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InputMissionDrop } from './InputMissionDrop';
import {
    InputMissionDropFromJSON,
    InputMissionDropFromJSONTyped,
    InputMissionDropToJSON,
} from './InputMissionDrop';

/**
 * 
 * @export
 * @interface InputSaveMissionDrops
 */
export interface InputSaveMissionDrops {
    /**
     * 
     * @type {Array<InputMissionDrop>}
     * @memberof InputSaveMissionDrops
     */
    drops: Array<InputMissionDrop>;
}

/**
 * Check if a given object implements the InputSaveMissionDrops interface.
 */
export function instanceOfInputSaveMissionDrops(value: object): boolean {
    if (!('drops' in value)) return false;
    return true;
}

export function InputSaveMissionDropsFromJSON(json: any): InputSaveMissionDrops {
    return InputSaveMissionDropsFromJSONTyped(json, false);
}

export function InputSaveMissionDropsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputSaveMissionDrops {
    if (json == null) {
        return json;
    }
    return {
        
        'drops': ((json['drops'] as Array<any>).map(InputMissionDropFromJSON)),
    };
}

export function InputSaveMissionDropsToJSON(value?: InputSaveMissionDrops | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'drops': ((value['drops'] as Array<any>).map(InputMissionDropToJSON)),
    };
}

